import {
    FragmentMappingConfig,
    InteroperableMetadata,
    InteroperableMetadataMap,
} from '../fragment-mapping-config';
import { IEntityFragment, IMappingProfile } from '@pf/shared-common';

import { PlatformCoreFragments } from './platform-core-fragments.enum';

export interface IVendorFragment extends IEntityFragment {
    vendorName?: string | null;
    vendorNumber?: string | null;
}

export type IVendorFragmentDto = IVendorFragment;

export function VendorFragmentMetadataMap<
    TFragmentDto extends IVendorFragmentDto,
    TFragment extends IVendorFragment,
>(config: FragmentMappingConfig<TFragmentDto, TFragment>): IMappingProfile {
    const interoperableMetadata = {
        vendorName: String,
        vendorNumber: String,
    } as InteroperableMetadata<TFragmentDto, TFragment>;
    return InteroperableMetadataMap(
        PlatformCoreFragments.Vendor,
        interoperableMetadata,
        config
    );
}

export const DefaultVendorFragmentMetadataMap = VendorFragmentMetadataMap<
    IVendorFragmentDto,
    IVendorFragment
>({});
